
import { Film } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface RelatedVideosProps {
  videos: any[];
}

const RelatedVideos = ({ videos }: RelatedVideosProps) => {
  if (!videos.length) return null;

  const getVideoId = (video: any) => {
    if (video.video_id) return video.video_id;
    if (video.internal_url) {
      const match = video.internal_url.match(/(?:youtu\.be\/|youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
      return match ? match[1] : null;
    }
    return null;
  };

  return (
    <div className="mb-6">
      <h3 className="font-semibold text-nation-blue mb-3 flex items-center text-sm">
        <Film size={16} className="mr-2" />
        Related Videos
      </h3>
      <div className="space-y-4">
        {videos.map((video, index) => {
          const videoId = getVideoId(video);
          if (!videoId) return null;
          
          return (
            <Card key={index}>
              <CardContent className="pt-4">
                <h4 className="text-sm font-medium mb-2">{video.title}</h4>
                <p className="text-sm text-muted-foreground mb-3">{video.description}</p>
                <div className="aspect-video">
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="rounded-md"
                  />
                </div>
              </CardContent>
            </Card>
          )
        })}
      </div>
    </div>
  );
};

export default RelatedVideos;
